































import TagModel from "@/ts/models/tagClass";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "TagChip",

  props: {
    tag: {
      type: Object as () => TagModel,
      default: undefined
    },
    closable: {
      type: Boolean,
      default: false
    },
    noselect: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    tiny: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: true
    }
  },

  setup() {
    return {};
  }
});
